import { MidiNote, midiNotes, StepType } from "../../reactronica";

export interface Props {
  currentStepIndex: number;
  steps: StepType[];
  instrument?: string;
  onClick: (steps: StepType[]) => void;
}

export interface ButtonAttributes {
  column: number;
  note: MidiNote;
}

export const notes: MidiNote[] = midiNotes
  .filter((n) => n.includes("3") || n.includes("4") || n.includes("5"))
  .reverse();
